import React from 'react'

import { RedFlagIcon } from './RedFlagIcon'
import { useAlertFlag } from './useAlertFlag'

export function AlertFlag({
  flag,
  tooltip,
  tooltipClassName = '',
  icon = <RedFlagIcon />,
  position = 'top',
}: {
  flag: string | string[]
  tooltip?: string
  tooltipClassName?: string
  icon?: React.ReactNode
  position?: 'top' | 'bottom' | 'right' | 'left'
}) {
  const { isFlagIncluded, tooltipText } = useAlertFlag({ flag, tooltip })

  if (!isFlagIncluded) {
    return null
  }

  return (
    <div
      className={`tooltip z-40 tooltip-${position} ${tooltipClassName}`}
      data-tip={tooltipText}
    >
      {icon || <RedFlagIcon />}
    </div>
  )
}
